<script>
import { onMounted } from 'vue'
import useAuth from '@/composables/useAuth'
import { useRouter } from '@/utils/index'

export default {
  setup() {
    const { router } = useRouter()
    const { logout, state: authState } = useAuth()

    onMounted(async () => {
      try {
        // Only logout if not already in progress
        if (!authState.isLoggingOut) {
          await logout()
        }
        router.push({ name: 'login' })
      } catch (error) {
        console.error(error)

        // Navigate to login even if logout fails
        router.push({ name: 'login' })
      }
    })

    return () => ''
  },
}
</script>
